import { ProjectItemGridView } from './ProjectItemGridView'
import { ProjectItemListView } from './ProjectItemListView'

export const ProjectItem = {
  Card: ProjectItemGridView,
  ListItem: ProjectItemListView,
}
